import React, { useCallback } from "react"
import { useSelector } from "react-redux"
import { Link } from "react-router-dom"
import { ListGroup, ListGroupItem } from "reactstrap"

const ProfileSearchResult = ({ data, query, close }) => {
  const { user } = useSelector((state) => state.user)
  const getText = useCallback(
    (tabName, url) => (
      <div className="d-flex gap-5">
        <div>
          <strong>{query}</strong> query found in <strong>{tabName}</strong>
        </div>
        <Link to={url} onClick={close}>
          <span className="text-small text-success cursor-pointer">View</span>
        </Link>
      </div>
    ),
    [query]
  )

  return (
    <ListGroup>
      {data?.userDetails && (
        <ListGroupItem>{getText("Login Details", "/profile")}</ListGroupItem>
      )}
      {user?.entity_type === "INDIVIDUAL" &&
        (data?.userDetails ||
          data?.aadhaarDetails ||
          data?.panDetails ||
          data?.additionalDetails) && (
          <ListGroupItem>
            {getText(
              "Personal Information",
              "/profile/kyc-details/personal-information"
            )}
          </ListGroupItem>
        )}
      {data?.bankDetails && (
        <ListGroupItem>
          {getText("Bank Details", "/profile/kyc-details/bank-details")}
        </ListGroupItem>
      )}
      {user?.entity_type === "COMPANY" &&
        (data?.aadhaarDetails ||
          data?.panDetails ||
          data?.additionalBusinessDetails) && (
          <ListGroupItem>
            {getText(
              "Authorised Person",
              "/profile/kyc-details/authorised-signatory"
            )}
          </ListGroupItem>
        )}

      {user?.entity_type === "COMPANY" &&
        (data?.userDetails ||
          data?.companyDetails ||
          data?.additionalBusinessDetails) && (
          <ListGroupItem>
            {getText(
              "Company Information",
              "/profile/kyc-details/company-information"
            )}
          </ListGroupItem>
        )}
    </ListGroup>
  )
}

export default ProfileSearchResult
